import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

const NormalCaseButton = styled(Button)({
	textTransform: "none"
});

export default NormalCaseButton;
